<template>
  <div class="EmployeeCard mb-24 text-left">
    <div class="pt-16 type-base flex flex-col gap-12 desk:gap-16">
      <div v-if="blok.image && blok.image.filename" class="aspect-portrait relative">
        <nuxt-img
          v-if="blok.image && blok.image.filename"
          preset="standard"
          loading="lazy"
          sizes="sm:100vw desk:1260px"
          class="absolute top-0 left-0 w-full h-full object-cover"
          :class="blok.focalPoint"
          :src="blok.image.filename"
          :alt="blok.image.alt || ''"
        />
      </div>
      <div class="flex flex-col gap-6 desk:gap-8">
        <div class="type-headline-md">{{ blok.name }}</div>
        <div class="flex flex-col gap-2 desk:gap-4">
          <div>{{ blok.title }}</div>
          <div class="text-text-subtle">{{ blok.location }}</div>
          <div class="text-text-subtle">{{ blok.area }}</div>
        </div>
      </div>
      <div class="flex flex-col gap-8">
        <div
          v-if="blok.mail.trim() !== ''"
          class="btn btn--text mobOnly:text-12"
        >
          <a
            :href="`mailto:${blok.mail}`"
            class="inline-flex items-center gap-8 opacity-60 hover:opacity-100 transition duration-300 ease-in-out"
          >
            <img
              src="/public/icons/mail.svg"
              alt="Mail"
              class="w-24 h-24"
            >
            <span class="hidden desk:inline-block">{{ blok.mail }}</span>
          </a>
        </div>
        <div
          v-if="blok.phone.trim() !== ''"
          class="btn btn--text mobOnly:text-12"
        >
          <a :href="`tel:${blok.phone}`" class="inline-flex items-center gap-8 opacity-60 hover:opacity-100 transition duration-300 ease-in-out">
            <img
              src="/public/icons/phone.svg"
              alt="Mail"
              class="w-24 h-24"
            >
            <span class="hidden desk:inline-block">{{ blok.phone }}</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { EmployeeCardProps } from '~/constants/types/storyblok';

defineProps<{
  blok: EmployeeCardProps,
}>();
</script>

<style scoped lang="postcss">
</style>
